import { memo } from 'react';
import { AnnotationContextGroup } from '../../../contexts/AnnotationContext';
import { T } from '../../../translation/src';
import { PropertiesSection, Property } from './PropertiesSection';
import { PropertyPanel } from '../../Properties/components/PropertyPanel';
import { TypeFilterButton, useTypeFilter } from './typeFilter';

interface GroupPropertiesProps {
  projectId: string;
  group: AnnotationContextGroup;
}
const GroupProperties_: React.FC2<GroupPropertiesProps> = ({ projectId, group }) => {
  const { availableKeys, selectedKeys, toggleKey, visibleIdentifiers, visibleTypes, visibleAnnotations, isGroupView } = useTypeFilter(group.annotations);

  return (
    <div className="flex flex-col space-y-4 divide-y divide-gray-800">
      <PropertiesSection title={<T _str="information" swc />}>
        <Property title={<T _str="type" swc />}>
          <T _str="group" swc />
        </Property>
        <Property title={<T _str="objects" swc />}>{group.annotations.length}</Property>
      </PropertiesSection>
      <PropertyPanel
        projectId={projectId}
        annotationTypes={visibleTypes}
        objectIdentifiers={visibleIdentifiers}
        selectedAnnotations={visibleAnnotations}
        isGroupView={isGroupView}
        headerAction={availableKeys.length > 1 ? <TypeFilterButton availableKeys={availableKeys} selectedKeys={selectedKeys} toggleKey={toggleKey} /> : undefined}
      />
    </div>
  );
};

export const GroupProperties = memo(GroupProperties_);
